<template>
    <div class="custom d-inline custom-prefix">
    <v-text-field
    type="number"
    color="primary"
    :label="label? label : $t('account-no-is-automatic-or-manual')"
    v-model="localValue"
    outlined
    dense
    :prefix="prefix" 
    @change="$emit('change')"
    @keydown.enter.prevent="$emit('keydown-enter-prevent')"
    ref="myInput"
    style="direction: ltr !important;"
    :rules="rules"
    :disabled="disabled"
    ></v-text-field>
    </div>
</template>
<script>
export default {
props: ["rules", "label", "value", "prefix", "disabled"],
name: "BeeAccountingNumber",
computed:{
    localValue: {
        get: function() {
            return this.value
        },
        set: function(value) {
            this.$emit('input', value)
        }
    }
},
methods:{
    setFocus() {
        this.$nextTick(()=> {
        this.$refs.myInput.focus();
    })
    }
},

    i18n:{
        messages: {
            ar: {
                'account-no-is-automatic-or-manual': 'رقم الحساب (آلي أو يدوي)'
            },
            en: {
                'account-no-is-automatic-or-manual': 'Account No. (auto or manual)'
            },
            es: {
                'account-no-is-automatic-or-manual': 'Número de cuenta (automático o manual)'
            },
        }
    }
}
</script>
<style>
/* .v-text-field__prefix {
    max-height: 32px;
    color: #346f86 !important ;
} */
.custom-prefix .v-text-field__prefix {
    max-height: 32px;
    color: #346f86 !important ;
    font-family: Calibri !important;
    font-weight: 600 !important;
    font-size: 1.05rem !important;
}
.custom input{
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>